import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function useTabs() {
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get('tabView') ?? undefined;

  const navigate = useNavigate();

  const onChangeTab = useCallback(
    (key: string) => navigate(`?tabView=${key}`),
    [navigate],
  );

  return {
    onChangeTab,
    currentTab,
  };
}
